module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state === 'editor') ? _c('quill-editor', {
    ref: "editor",
    attrs: {
      "options": _vm.quillOptions
    },
    model: {
      value: (_vm.part.content),
      callback: function($$v) {
        _vm.$set(_vm.part, "content", $$v)
      },
      expression: "part.content"
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.part.content)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00412a19","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/numbered-list.vue
// module id = 500
// module chunks = 0